import React, { useEffect } from 'react';

/**
 * Redirect page for Stripe Connect return from the driver app.
 * Stripe redirects here (e.g. /stripe-app-return?stripe_success=true); we redirect to
 * buydropdriver://stripe-return so the app opens. Used when return URL is the live website.
 */
const StripeAppReturn: React.FC = () => {
  useEffect(() => {
    const qs = window.location.search || '';
    const url = `buydropdriver://stripe-return${qs}`;
    window.location.href = url;
  }, []);

  return (
    <div className="min-h-[40vh] flex items-center justify-center">
      <p className="text-gray-600">Returning to Buy Drop…</p>
    </div>
  );
};

export default StripeAppReturn;
